import React, { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';

import { useGetMyLibraryQuery } from '@/modules/services';

import { getQueryString } from '@/lib/util';

import MyLibraryView from './MyLibraryView';

import './MyLibrary.scss';
import { appData } from '@/lib/data';
import { ElearningDataType, PaginationType } from '@/modules/types/elearning';

const MyLibrary = (): ReactElement => {
  const location = useLocation();
  const handleError = useErrorHandler();

  const { isError, isLoading, data, error } = useGetMyLibraryQuery(
    getQueryString(location.search, {
      ...appData.pagination.defaultParams,
      sort: 'ma',
      order: 'DESC',
    }),
  );

  if (isError) {
    handleError(error);

    return <div />;
  }

  const showElearning = (
    elearningData: PaginationType<ElearningDataType> | undefined,
  ) => (elearningData ? <MyLibraryView /> : <div>no data</div>);

  return isLoading ? <div className="loading" /> : showElearning(data);
};

export default MyLibrary;
